import RedirectPage from "./RedirectPage";

export default RedirectPage;

export * from "./RedirectPage";
